"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var getConsents = function getConsents(publisherId) {
  var API_URL = (0, _environmentHelper.default)();
  return fetch("".concat(API_URL, "/publishers/").concat(publisherId, "/consents"), {
    method: 'GET'
  }).then( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(res) {
      var _yield$res$json, responseData, errors;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return res.json();
          case 2:
            _yield$res$json = _context.sent;
            responseData = _yield$res$json.responseData;
            errors = _yield$res$json.errors;
            if (res.ok) {
              _context.next = 7;
              break;
            }
            throw new Error(errors[0]);
          case 7:
            return _context.abrupt("return", responseData);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).catch(function (err) {
    throw new Error(err);
  });
};
var _default = getConsents;
exports.default = _default;